import {createSlice} from "@reduxjs/toolkit";

const initialLinksState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  sampleList: null,
  sample: undefined,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const samplesSlice = createSlice({
  name: "samples",
  initialState: initialLinksState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findLinks
    samplesFetched: (state, action) => {
      const { totalCnt, reqSampleList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.sampleList = reqSampleList;
      state.totalCount = totalCnt;
    },
    // getLinkById
    sampleFetched: (state, action) => {
      const { sample } = action.payload;
      state.actionsLoading = false;
      state.sample = sample;
      state.error = null;
    },
  }
});
